
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';
import { Separator } from '@/components/ui/separator';

interface ProcessStep {
  title: string;
  description: string;
}

interface BespokeProcessSectionProps {
  steps: ProcessStep[];
}

const BespokeProcessSection: React.FC<BespokeProcessSectionProps> = ({ steps }) => {
  return (
    <section className="py-20 bg-forti-fi-background" aria-labelledby="process-heading">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-center mb-16">
          <div className="h-0.5 bg-gold w-20 mb-4"></div>
          <h2 id="process-heading" className="text-3xl md:text-4xl text-center font-serif text-forti-fi mb-6">Our Process</h2>
          <p className="text-lg text-center text-forti-fi-charcoal max-w-3xl">
            Our approach to custom security solutions is methodical and collaborative,
            ensuring your unique needs are met with precision and care.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          {/* Left side: Process steps */}
          <div className="md:col-span-6 space-y-12">
            {steps.map((step, index) => (
              <AnimateInView key={index} animation="slide-up" delay={index * 100} className="flex gap-6">
                <div className="flex-shrink-0 mt-1">
                  <span className=" flex items-center justify-center">
                    {index + 1}
                  </span>
                </div>
                <div>
                  <h3 className="text-xl font-serif text-forti-fi mb-2">{step.title}</h3>
                  <p className="text-forti-fi-charcoal">{step.description}</p>
                </div>
              </AnimateInView>
            ))}
          </div>
          
          {/* Right side: Image */}
          <div className="md:col-span-6 flex items-center justify-center">
            <AnimateInView animation="fade-in">
              <img 
                src="/images/Solutions-Bespoke-Hero-Option-1.png" 
                alt="Security assessment process" 
                className="w-full h-auto object-cover rounded-lg shadow-md max-w-xl mx-auto"
                loading="lazy"
              />
            </AnimateInView>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BespokeProcessSection;
